import { useQuery } from "react-query";
import { getSalesLead } from "../../../../../actions/Utilities/SalesLead";

export default function useGetSalesLead() {
  return useQuery("SalesLead", getSalesLead, {
    refetchOnWindowFocus: false,
  });
}
